import { FormattedMessage } from "react-intl";
import { Divider, Flex, Text } from "@paguelofacil/pf-components";

import { dictionaryPaymentMethod } from "../../services/utils/Constants";
import { language, languageDefault } from "../../services/utils/Language";
import useStore from "../../services/store/useStore";
import { useGetEstimateAmount } from "../../hooks/useGetEstimateAmount";
import { formattedDate } from "../../utils/helpers";

export const TransactionInformation = () => {
    const receiveData = useStore(state => state.receiveData);
    const { costs, isLoading } = useGetEstimateAmount("ZINLI");

    return (
        <Flex direction="column" gap="1rem">
            <Flex direction="column" className="container-info-payment">
                <Flex direction="row" wrap="nowrap" justify="space-between" gap="0.25rem">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage id={language.date_hour} defaultMessage={languageDefault.date_hour} />:
                    </Text>{" "}
                    <Text variant="body5">{formattedDate(receiveData.date)}</Text>
                </Flex>
                {/* <Flex direction="row" justify="space-between" gap="0.25rem">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage id={language.state} defaultMessage={languageDefault.state} />:
                    </Text>{" "}
                    <Text color={dictionaryPaymentMethod.status[statusPayment]?.color} variant="body5">
                        <FormattedMessage
                            id={dictionaryPaymentMethod.status[statusPayment]?.keyTranslate}
                            defaultMessage={dictionaryPaymentMethod.status[statusPayment]?.label}
                        />
                    </Text>
                </Flex> */}
                <Flex direction="row" wrap="nowrap" justify="space-between" gap="0.25rem">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage
                            id={language.payment_method}
                            defaultMessage={languageDefault.payment_method}
                        />
                        :
                    </Text>{" "}
                    <Text variant="body5" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <FormattedMessage
                            id={dictionaryPaymentMethod.keyTranslate}
                            defaultMessage={dictionaryPaymentMethod.defaultValueTranslate}
                        />
                    </Text>
                </Flex>
                <Flex direction="row" wrap="nowrap" justify="space-between" gap="0.25rem">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage id={language.details} defaultMessage={languageDefault.details} />:
                    </Text>{" "}
                    <Flex direction="column" justify="flex-end" align="flex-end" gap="0.25rem" minW="auto">
                        <Text variant="body5">{`${receiveData.method} ${receiveData.coin} - ${receiveData.network}`}</Text>
                        <Text variant="body5">{receiveData.address}</Text>
                    </Flex>
                </Flex>
            </Flex>
            <Divider />
            <Flex direction="column" align="flex-start">
                <Flex direction="row" justify="space-between" gap="0.25rem">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage
                            id={language.amount_recharged}
                            defaultMessage={languageDefault.amount_recharged}
                        />
                        :
                    </Text>
                    <Text variant="body5">{isLoading ? "Loading..." : `$ ${costs.amountToReceive} USD`}</Text>
                </Flex>
                <Flex direction="row" justify="space-between" gap="0.25rem">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage id={language.commission} defaultMessage={languageDefault.commission} />:
                    </Text>
                    <Text variant="body5">
                        <FormattedMessage
                            id={language.depend_network}
                            defaultMessage={languageDefault.depend_network}
                        />
                    </Text>
                </Flex>
            </Flex>
            <Divider />
            <Flex direction="column" gap="0.25" align="flex-start">
                <Flex direction="row" justify="space-between" gap="0.25rem" className="container-total-amount">
                    <Text variant="body5" weight="regular">
                        <FormattedMessage id={language.total} defaultMessage={languageDefault.total} />:
                    </Text>
                    <Text variant="body2">$ {receiveData.amountUsd} USD</Text>
                </Flex>
                <Flex direction="column" justify="flex-end" align="flex-end">
                    <Text variant="body6" color="#7D889B" weight="regular">{`${receiveData.cryptoAmount}`}</Text>
                </Flex>
            </Flex>
            <Divider />
            <Flex direction="column" align="flex-start">
                <Flex direction="row" justify="space-between" gap="0.25rem">
                    <Text variant="body6" weight="regular" color="#515A69">
                        <FormattedMessage id={language.state_suppler} defaultMessage={languageDefault.state_suppler} />:
                    </Text>
                    <Text variant="body6" color="#515A69">
                        <FormattedMessage id={language.unknown} defaultMessage={languageDefault.unknown} />
                    </Text>
                </Flex>
                <Flex direction="row" justify="space-between" gap="0.25rem">
                    <Text variant="body6" weight="regular" color="#515A69">
                        <FormattedMessage id={language.tx_id} defaultMessage={languageDefault.tx_id} />:
                    </Text>
                    <Text variant="body6" color="#515A69">
                        <FormattedMessage id={language.unknown} defaultMessage={languageDefault.unknown} />
                    </Text>
                </Flex>
            </Flex>
        </Flex>
    );
};
